/* eslint-disable @nx/enforce-module-boundaries */
import { HStack, Stack, Box } from '@mybridge/ui/layout';
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PostFormContext } from '../context';
import { Divider, IconButton, Spinner, Textarea } from '@mybridge/ui';
import { PostAvatar } from 'v4/components/post-form/post-avatar';
import { PostVisibilityMenu } from 'v4/components/post-form/post-visibility-menu';
import { DeleteIcon, PlusIcon } from '@mybridge/icons';
import { background, border } from '@chakra-ui/react';
import { Avatar } from '@mybridge/ui/avatar';
import { AttachedMediaContainer } from '../attached-media-display';
import { AvailableMediaContainer } from '../available-media-display';
import { postDelete } from 'v4/store/actions/post.actions';
import { AvailableEditableMediaContainer } from '../available-editable-media-display';
import {
  Editor,
  EditorState,
  Modifier,
  RichUtils,
  ContentState,
  SelectionState,
  CompositeDecorator,
} from 'draft-js';
import { currentProfile } from 'v4/store/actions/user-profile.actions';
import { PostBoxContext } from 'v4/components/post/context';
import { DeleteChildPost } from 'v4/components/post/post-actions-modals/delete-post/deleteChildPost';
import { FrameIcon } from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
import API from 'v4/store/common/api';
import { PostBoxBody } from 'v4/components/post/body';
import { PostBoxHeader as PostBoxHeaderDisplay } from 'v4/components/post/header';
export const PostFormHeader = ({
  companyDetails,
  setOpenPostModal,
  openPostModal,
  placeholderText,
  multiPost,
  editingIndexHandler = () => {},
  editingIndex,
  isPostModalOpen,
  fromQuote=false,
  pagePost=false,
  fromProfile=false,
  mentionOptions = [],
  hashtagOptions = [],
  onMentionSelect,
  onHashtagSelect,
  repost,
  repostBoxContext,
}) => {
  const {
    expanded,
    setExpanded,
    feeling: feelings,
    setFeeling,
    setIsDisable,
    tagged,
    submitPost,
    mode,
    setText,
    images,
    gifs,
    videos,
    text,
    setGifs,
    setVideos,
    setImages,
    setTagged,
    setMultiPost,
    isRemoved,
    setIsRemoved,
    visibility,
    setVisibility,
    postEditorData,
    emojis,
    setEmojis,
    setPostEditorData,
    isCompany,
    setIsCompany,
    setShouldChange,
    shouldChange,
    // isLoading,
    EditorDefaultState,
    textareaRef, // Use textareaRef from context instead of defining it locally
  taggedListUsers,
    caretPosition,
    setCaretPosition,
    mentionedUser,
    setMentionedUser,
    cancelUpload,
    cancelAll,
  } = useContext(PostFormContext) ?? {};
  const { deletePost } = useContext(PostBoxContext);
  const { formatNumber } = useNumberFormatter();

  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  const handleTextClick = (e) => {
    setExpanded(true);
    setOpenPostModal && setOpenPostModal(true);
  };
  const { t } = useTranslator();
  const { feelingsAndActivitiesArr } = useSelector((s) => s.globalData) ?? {};
  const feeling = feelingsAndActivitiesArr?.find?.((v) => v.id == feelings?.id);
  const { currentProfile: selectedPostingProfile } = useSelector(
    (state) => state.userProfile
  );
  const findWithRegex = useCallback((regex, contentBlock, callback) => {
    const text = contentBlock.getText();
    let matchArr;
    while ((matchArr = regex.exec(text)) !== null) {
      const start = matchArr.index + (matchArr[1] ? matchArr[1].length : 0);
      const end = start + matchArr[2].length;
      callback(start, end);
    }
  }, []);

  const mentionStrategy = useCallback(
    (contentBlock, callback, contentState) => {
      findWithRegex(/(^|\s)(@[^\s@#]+(\s[^\s@#]+)*)/g, contentBlock, callback);
    },
    [findWithRegex]
  );

  const hashtagStrategy = useCallback(
    (contentBlock, callback, contentState) => {
      findWithRegex(/(^|\s)(#[^\s@#]+)/g, contentBlock, callback);
    },
    [findWithRegex]
  );

  const MentionSpan = useCallback((props) => {
    return (
      <span className="mention" style={{ color: '#488FEC', fontWeight: 600 }}>
        {props.children}
      </span>
    );
  }, []);


  const HashtagSpan = useCallback(
    (props) => (
      <span style={{ color: '#488FEC', fontWeight: 600 }}>{props.children}</span>
    ),
    []
  );

  const getMediaIdentity = useCallback((entry) => {
    if (!entry) return '';
    if (entry instanceof File) {
      return `${entry.name}-${entry.size}-${entry.lastModified}`;
    }
    if (typeof entry === 'string') {
      return entry;
    }
    return entry.file || entry.url || entry.id || '';
  }, []);

  const isSameMediaList = useCallback((currentMedia = [], nextMedia = []) => {
    if (currentMedia.length !== nextMedia.length) return false;
    return currentMedia.every(
      (media, index) =>
        getMediaIdentity(media) === getMediaIdentity(nextMedia[index])
    );
  }, [getMediaIdentity]);

  const mentionHashtagDecorator = useMemo(
    () =>
      new CompositeDecorator([
        { strategy: mentionStrategy, component: MentionSpan },
        { strategy: hashtagStrategy, component: HashtagSpan },
      ]),
    [MentionSpan, HashtagSpan, hashtagStrategy, mentionStrategy]
  );

  const decorateState = useCallback(
    (state) =>
      EditorState.set(state, {
        decorator: mentionHashtagDecorator,
      }),
    [mentionHashtagDecorator]
  );

  const [newTextState, setNewTextState] = useState(() =>
    decorateState(EditorState.createEmpty(mentionHashtagDecorator))
  );
  const [isRemoveChildModalOpen, setIsRemoveChildModalOpen] = useState(false);
  const [deletedChildId, setdeletedChildId] = useState(null);
  const [charCount, setCharCount] = useState(0);
  const [activeTrigger, setActiveTrigger] = useState(null);
  const [suggestionQuery, setSuggestionQuery] = useState('');
  const [showSuggestionList, setShowSuggestionList] = useState(false);
  const lastSelectionRef = useRef(null);
  const lastTextareaSelectionRef = useRef({ start: 0, end: 0 });
  // Array of refs for each multiPost textarea (create mode + edit mode)
  const textareaRefs = useRef([]);
  const charLimit = 250;
  const [apiMentionUsers, setApiMentionUsers] = useState([]);
  const [apiMentionUsersFetching, setApiMentionUsersFetching] = useState(false);
  const [apiHashtags, setApiHashtags] = useState([]);
  const [apiHashtagsFetching, setApiHashtagsFetching] = useState(false);
  const searchTimeoutRef = useRef(null);



 



  const getSuggestionLabel = useCallback(
    (option, triggerType) => {
      if (!option) return '';
      if (triggerType === 'mention') {
        if (option.full_name) {
          return option.full_name;
        }
        const first = option.first_name || option.firstName || '';
        const last = option.last_name || option.lastName || '';
        const fullName = `${first} ${last}`.trim();
        return fullName || option.name || option.display_name || '';
      }
      // For hashtags, return the tag with # prefix
      if (triggerType === 'hashtag') {
        const tag = option.tag || option.name || option.label || option.title || '';
        return tag.startsWith('#') ? tag : `#${tag}`;
      }
      return option.label || option.name || option.tag || option.title || '';
    },
    []
  );

  const getSuggestionAvatar = useCallback((option) => {
    if (!option) return '';
    return (
      option.avatar ||
      option.profile_pic ||
      option.image ||
      option.profilePic ||
      ''
    );
  }, []);

  const resolvedMentionOptions = useMemo(() => {
    if (apiMentionUsers?.length) {
      return apiMentionUsers;
    }
    return mentionOptions?.length ? mentionOptions : taggedListUsers || [];
  }, [mentionOptions, taggedListUsers, apiMentionUsers]);

  const resolvedHashtagOptions = useMemo(() => {
    if (apiHashtags?.length) {
      return apiHashtags;
    }
    return hashtagOptions?.length ? hashtagOptions : [];
  }, [hashtagOptions, apiHashtags]);

  const filteredSuggestions = useMemo(() => {
    if (!activeTrigger) return [];
    const source =
      activeTrigger === 'mention'
        ? resolvedMentionOptions ?? []
        : resolvedHashtagOptions ?? [];
    const query = suggestionQuery?.toLowerCase?.() || '';
    return source
      .filter((option) => {
        const label = getSuggestionLabel(option, activeTrigger)
          ?.toLowerCase?.() || '';
        return !query || label.includes(query);
      })
      .slice(0, 8);
  }, [
    activeTrigger,
    getSuggestionLabel,
    resolvedHashtagOptions,
    resolvedMentionOptions,
    suggestionQuery,
  ]);

  useEffect(() => {
    const currentContent = newTextState.getCurrentContent();
    setCharCount(currentContent.getPlainText('').length);
  }, [newTextState]);

  const handleCursorUpdate = useCallback((element = null) => {
    setTimeout(() => {
      // Use the passed element, or fall back to the active textareaRefs entry, or document.activeElement
      const el = element || textareaRefs.current[editingIndex] || document.activeElement || textareaRef?.current;
      if (el && el.tagName === 'TEXTAREA') {
        const position = el.selectionStart ?? 0;
        setCaretPosition(position);
        // Keep the shared context ref in sync with the currently active textarea
        if (textareaRef) textareaRef.current = el;
      }
    }, 0);
  }, [editingIndex, textareaRef, setCaretPosition]);

  const isCharLimitReached = charCount >= charLimit+1;

  useEffect(() => {
    if (mode === 'edit'&&!fromQuote) {
      const contentState = ContentState.createFromText(text);
      setNewTextState(
        decorateState(
          EditorState.createWithContent(contentState, mentionHashtagDecorator)
        )
      );
    } else {
      setNewTextState(decorateState(postEditorData));
    }
  }, []);
  
  useEffect(() => {
    setPostEditorData(newTextState);
  }, [newTextState]);

  const resetSuggestions = useCallback(() => {
    setShowSuggestionList(false);
    setActiveTrigger(null);
    setSuggestionQuery('');
    setApiMentionUsers([]);
    setApiHashtags([]);
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
      searchTimeoutRef.current = null;
    }
  }, []);

  const fetchUsersFromAPI = useCallback(async (query) => {
    if (!query || query.trim().length === 0) {
      setApiMentionUsers([]);
      return;
    }

    setApiMentionUsersFetching(true);

    try {
      const response = await API({
        url: `api/v1/search/users/?q=${encodeURIComponent(query)}`,
        method: 'GET',
      });

      if (response?.status && response?.data && Array.isArray(response.data)) {
        const transformedUsers = response.data.map((user) => ({
          id: user.id,
          slug: user.slug,
          full_name: user.full_name,
          name: user.full_name,
          first_name: user.full_name?.split(' ')[0] || '',
          last_name: user.full_name?.split(' ').slice(1).join(' ') || '',
          profile_pic: user.profile_pic,
          avatar: user.profile_pic,
          company_name: user.company_name,
          position: user.position,
          location: user.location,
          headline: user.position || user.company_name || '',
        }));
        setApiMentionUsers(transformedUsers);
      } else {
        setApiMentionUsers([]);
      }
      setApiMentionUsersFetching(false);
    } catch (error) {
      console.error('Error fetching users:', error);
      setApiMentionUsers([]);
      setApiMentionUsersFetching(false);
    }
  }, []);

  const fetchHashtagsFromAPI = useCallback(async (query) => {
    if (!query || query.trim().length === 0) {
      setApiHashtags([]);
      return;
    }

    setApiHashtagsFetching(true);

    try {
      const response = await API({
        url: `api/v1/search/hashtags/?q=${encodeURIComponent(query)}`,
        method: 'GET',
      });

      if (response?.status && response?.data && Array.isArray(response.data)) {
        // Transform hashtag response to match expected format
        const transformedHashtags = response.data.map((hashtag) => ({
          id: hashtag.id,
          tag: hashtag.tag,
          count: hashtag.count || 0,
        }));
        setApiHashtags(transformedHashtags);
      } else {
        setApiHashtags([]);
      }
      setApiHashtagsFetching(false);
    } catch (error) {
      console.error('Error fetching hashtags:', error);
      setApiHashtags([]);
      setApiHashtagsFetching(false);
    }
  }, []);

  const detectSuggestions = useCallback(
    (contentState, selectionState) => {
      if (!selectionState?.getHasFocus?.()) {
        resetSuggestions();
        return;
      }

      const blockKey = selectionState.getAnchorKey();
      const block = contentState.getBlockForKey(blockKey);
      if (!block) {
        resetSuggestions();
        return;
      }

      const textUntilCursor = block
        .getText()
        ?.slice(0, selectionState.getAnchorOffset());
      const triggerMatch = /(^|\s)([@#])([^\s@#]*)$/.exec(textUntilCursor);

      if (triggerMatch) {
        const triggerType = triggerMatch[2] === '@' ? 'mention' : 'hashtag';
        const query = triggerMatch[3] || '';
        setActiveTrigger(triggerType);
        setSuggestionQuery(query);
        setShowSuggestionList(true);

        if (triggerType === 'mention') {
          if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
          }
          searchTimeoutRef.current = setTimeout(() => {
            fetchUsersFromAPI(query);
          }, 300);
        } else if (triggerType === 'hashtag') {
          if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
          }
          searchTimeoutRef.current = setTimeout(() => {
            fetchHashtagsFromAPI(query);
          }, 300);
        }
      } else {
        resetSuggestions();
      }
    },
    [resetSuggestions, fetchUsersFromAPI, fetchHashtagsFromAPI]
  );

  const detectSuggestionsPlain = useCallback(
    (textValue = '', cursorOffset = 0) => {
      const textUntilCursor = textValue.slice(0, cursorOffset);
      const triggerMatch = /(^|\s)([@#])([^\s@#]*)$/.exec(textUntilCursor);
      if (triggerMatch) {
        const triggerType = triggerMatch[2] === '@' ? 'mention' : 'hashtag';
        const query = triggerMatch[3] || '';
        setActiveTrigger(triggerType);
        setSuggestionQuery(query);
        setShowSuggestionList(true);

        if (triggerType === 'mention') {
          if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
          }
          searchTimeoutRef.current = setTimeout(() => {
            fetchUsersFromAPI(query);
          }, 300);
        } else if (triggerType === 'hashtag') {
          if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
          }
          searchTimeoutRef.current = setTimeout(() => {
            fetchHashtagsFromAPI(query);
          }, 300);
        }
      } else {
        resetSuggestions();
      }
    },
    [resetSuggestions, fetchUsersFromAPI, fetchHashtagsFromAPI]
  );

  const escapeHtml = useCallback((str = '') => {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }, []);

  const highlightMentionsHashtags = useCallback(
    (value = '') => {
      const safe = escapeHtml(value);
      return safe.replace(
        /(@[^\s@#]+(\s[^\s@#]+)*|#[^\s@#]+)/g,
        '<span style="color:#488FEC;font-weight:normal;display:inline;letter-spacing:normal;">$1</span>'
      );
    },
    [escapeHtml]
  );

  const insertMentionInTextarea = useCallback(
    (item, triggerType) => {
      // Use the ref for the currently active textarea (array ref first, then shared context ref)
      const ref = textareaRefs.current[editingIndex] ?? textareaRef?.current;
      if (!ref) return;
      const triggerChar = triggerType === 'mention' ? '@' : '#';
      const currentText = ref.value || '';
      const cursorPos = ref.selectionStart ?? currentText.length;

      let triggerIndex = currentText.lastIndexOf(
        triggerChar,
        Math.max(cursorPos - 1, 0)
      );
      if (triggerIndex === -1) return;

      while (triggerIndex > 0 && currentText[triggerIndex - 1] === triggerChar) {
        triggerIndex -= 1;
      }

      let replaceEnd = cursorPos;
      while (
        replaceEnd < currentText.length &&
        currentText[replaceEnd] === triggerChar
      ) {
        replaceEnd += 1;
      }
      while (
        replaceEnd < currentText.length &&
        currentText[replaceEnd] !== ' ' &&
        replaceEnd < currentText.length &&
        !['\n', '\t', '@', '#'].includes(currentText[replaceEnd])
      ) {
        replaceEnd += 1;
      }

      let label = getSuggestionLabel(item, triggerType);
      // Remove # prefix if it's already there for hashtags
      if (triggerType === 'hashtag' && label.startsWith('#')) {
        label = label.substring(1);
      }
      // Add two spaces for mentions to ensure proper detection (name has one space, second space is delimiter)
      const replacementText = triggerType === 'mention' 
        ? `${triggerChar}${label}  `
        : `${triggerChar}${label} `;
      const before = currentText.slice(0, triggerIndex);
      const after = currentText.slice(replaceEnd);
      const nextText = `${before}${replacementText}${after}`;

      ref.value = nextText;
      const nextCaret = before.length + replacementText.length;
      ref.setSelectionRange(nextCaret, nextCaret);

      if (editingIndex !== null && Array.isArray(multiPost)) {
        setMultiPost((prev) =>
          prev.map((p, i) =>
            i === editingIndex ? { ...p, content: nextText } : p
          )
        );
      }
      setText(nextText);
    },
    [
      editingIndex,
      getSuggestionLabel,
      multiPost,
      setMultiPost,
      setText,
      textareaRef,
    ]
  );

  const insertMentionInEditor = useCallback(
    (item, triggerType) => {
      const contentState = newTextState.getCurrentContent();
      const selectionState =
        lastSelectionRef.current || newTextState.getSelection();
      const blockKey = selectionState.getAnchorKey();
      const block = contentState.getBlockForKey(blockKey);
      if (!block) return;

      const triggerChar = triggerType === 'mention' ? '@' : '#';
      const anchorOffset = selectionState.getAnchorOffset();
      const blockText = block.getText();

      const textUntilCursor = blockText.slice(0, anchorOffset);
      const triggerMatch = /(^|\s)([@#])([^\s@#]*)$/.exec(textUntilCursor);
      const triggerIndex = triggerMatch
        ? triggerMatch.index + (triggerMatch[1]?.length || 0)
        : blockText.lastIndexOf(triggerChar, Math.max(anchorOffset - 1, 0));
      if (triggerIndex === -1) return;
      const typedChunkLength =
        (triggerMatch?.[2]?.length || 1) + (triggerMatch?.[3]?.length || 0);
      const replaceEnd =
        typedChunkLength > 0
          ? triggerIndex + typedChunkLength
          : Math.max(anchorOffset, triggerIndex + 1);

      let label = getSuggestionLabel(item, triggerType);
      // Remove # prefix if it's already there for hashtags
      if (triggerType === 'hashtag' && label.startsWith('#')) {
        label = label.substring(1);
      }
      // Add two spaces for mentions to ensure proper detection (name has one space, second space is delimiter)
      const replacementText = triggerType === 'mention' 
        ? `${triggerChar}${label}  `
        : `${triggerChar}${label} `;
      const replaceSelection = selectionState.merge({
        anchorOffset: triggerIndex,
        focusOffset: Math.max(replaceEnd, anchorOffset),
      });

      const newContentState = Modifier.replaceText(
        contentState,
        replaceSelection,
        replacementText
      );
      const pushedState = EditorState.push(
        newTextState,
        newContentState,
        'insert-characters'
      );
      const nextSelection = replaceSelection.merge({
        anchorOffset: triggerIndex + replacementText.length,
        focusOffset: triggerIndex + replacementText.length,
        hasFocus: true,
      });
      const withSelection = EditorState.forceSelection(
        pushedState,
        nextSelection
      );

      lastSelectionRef.current = nextSelection;

      setNewTextState(withSelection);
      setPostEditorData(withSelection);
      setText(newContentState.getPlainText());
    },
    [
      getSuggestionLabel,
      newTextState,
      setPostEditorData,
      setText,
    ]
  );

  const handleSuggestionSelect = useCallback(
    (item, triggerType) => {
      if (!item || !triggerType) return;

      if (mode === 'edit' && editingIndex !== null) {
        insertMentionInTextarea(item, triggerType);
      } else {
        insertMentionInEditor(item, triggerType);
      }
      resetSuggestions();

      if (triggerType === 'mention') {
        onMentionSelect?.(item);
        const name =
          getSuggestionLabel(item, 'mention') ||
          [item.first_name, item.last_name].filter(Boolean).join(' ') ||
          item.name ||
          item.display_name ||
          '';
        const formatted = {
          id: item.id,
          slug: item.slug || item.user_slug || item.userSlug,
          name,
        };
        setMentionedUser?.((prev = []) => {
          const exists = prev.some(
            (u) =>
              (u.id && formatted.id && u.id === formatted.id) ||
              (u.slug && formatted.slug && u.slug === formatted.slug)
          );
          if (exists) {
            return prev;
          }
          const next = [...prev, formatted];
          return next;
        });
      } else {
        onHashtagSelect?.(item);
      }
    },
    [
      editingIndex,
      getSuggestionLabel,
      insertMentionInEditor,
      insertMentionInTextarea,
      mode,
      onHashtagSelect,
      onMentionSelect,
      resetSuggestions,
      setMentionedUser,
    ]
  );

  const handleEditorChange = useCallback(
    (newState) => {


      setIsRemoved(false);
                      
      const currentContent = newState.getCurrentContent();
      const plainText = currentContent.getPlainText();
      const selection = newState.getSelection();
      
      // Update cursor position in context for Draft.js editor
      const firstBlock = currentContent.getFirstBlock();
      if (selection.getAnchorKey() === firstBlock.getKey()) {
        setCaretPosition(selection.getAnchorOffset());
      }

      // Update the editor state
      setNewTextState(newState);

      // Update the text state
      setText(plainText);

      // Update the post editor data
      setPostEditorData(newState);

      // Detect and remove mentions that are no longer in the text
      if (mentionedUser && mentionedUser.length > 0) {
        const mentionPattern = /@([^\n@#]+)/g;
        const mentionedNames = [];
        let match;
        while ((match = mentionPattern.exec(plainText)) !== null) {
          mentionedNames.push(match[1].trim().toLowerCase());
        }
        
        setMentionedUser((prev) => {
          return prev.filter((user) => {
            const userName = (user.name || '').toLowerCase();
            return mentionedNames.some((name) => userName.includes(name) || name.includes(userName));
          });
        });
      }


      // setIsRemoved(false);

      // const currentContent = newState.getCurrentContent();
      // const plainText = currentContent.getPlainText();

       // keep track of cursor so suggestions insert at correct spot after click
      lastSelectionRef.current = newState.getSelection();

     
      detectSuggestions(currentContent, newState.getSelection());
    },
    [detectSuggestions, setPostEditorData, setText, setIsRemoved, mentionedUser, setMentionedUser]
  );
  
  useEffect(() => {
    if (emojis.length > 0) {
      const stateEmoji = [...emojis];
      const emoj = stateEmoji.shift();
  
      // Check if we're editing a specific post in multiPost array
      const isEditingMultiPost = 
        editingIndex != null && 
        multiPost?.length > editingIndex && 
        multiPost[editingIndex];
  
      if (isEditingMultiPost) {
        // Update only the post being edited (textarea in edit mode)
        setMultiPost((prevPosts) =>
          prevPosts.map((post, index) => {
            if (index === editingIndex) {
              const currentContent = post.content || '';
              // Use cursor position from context
              const startPos = caretPosition !== null ? caretPosition : currentContent.length;
              const newContent =
                currentContent.substring(0, startPos) +
                emoj.native +
                currentContent.substring(startPos);

              // Update cursor position after inserting emoji
              const newCursorPos = startPos + emoj.native.length;
              setCaretPosition(newCursorPos);
              setText(newContent);
              
              // Update textarea cursor position - find the correct textarea by index
              setTimeout(() => {
                // Find textareas in edit mode posts
                const allHStacks = document.querySelectorAll('.postHasChildCreate');
                const targetHStack = Array.from(allHStacks).find((_, idx) => idx === editingIndex);
                if (targetHStack) {
                  const textarea = targetHStack.querySelector('textarea');
                  if (textarea && textarea.tagName === 'TEXTAREA') {
                    textarea.focus();
                    textarea.selectionStart = textarea.selectionEnd = newCursorPos;
                    // Update cursor in context
                    handleCursorUpdate(textarea);
                  }
                }
              }, 0);

              return { ...post, content: newContent };
            }
            return post;
          })
        );
      } else {
        // Update the main editor only (create mode - uses Draft.js Editor)
        setNewTextState((prevEditorState) => {
          const currentContent = prevEditorState.getCurrentContent();
          let selection = prevEditorState.getSelection();
          
          // Get the first block (Draft.js typically uses single block for plain text)
          const firstBlock = currentContent.getFirstBlock();
          const blockKey = firstBlock.getKey();
          const blockLength = firstBlock.getLength();
          
          // Use caretPosition from context if available, otherwise use current selection
          let insertPosition = blockLength;
          if (caretPosition !== null && caretPosition !== undefined) {
            insertPosition = Math.min(caretPosition, blockLength);
          } else {
            // Check if selection is on the correct block and within bounds
            const anchorOffset = selection.getAnchorOffset();
            const isSelectionValid = 
              selection.getAnchorKey() === blockKey && 
              anchorOffset >= 0 && 
              anchorOffset <= blockLength;
            
            if (isSelectionValid) {
              insertPosition = anchorOffset;
            }
          }
          
          // Create selection at the insert position
          selection = SelectionState.createEmpty(blockKey).merge({
            anchorOffset: insertPosition,
            focusOffset: insertPosition,
          });
          
          // Insert emoji at the cursor position using Draft.js Modifier
          const newContentState = Modifier.insertText(
            currentContent,
            selection,
            emoj.native
          );
          
          // Create new editor state with updated content
          const newEditorState = EditorState.push(
            prevEditorState,
            newContentState,
            'insert-characters'
          );
          
          // Move cursor to the end of inserted text
          const newCursorPos = insertPosition + emoj.native.length;
          const newSelection = SelectionState.createEmpty(blockKey).merge({
            anchorOffset: newCursorPos,
            focusOffset: newCursorPos,
          });
          
          const finalEditorState = EditorState.forceSelection(
            newEditorState,
            newSelection
          );

          const updatedText = newContentState.getPlainText();
          setPostEditorData(finalEditorState);
          setText(updatedText);
          
          // Update caret position in context
          setCaretPosition(newCursorPos);
          
          return finalEditorState;
        });
      }
  
      // remove processed emoji
      setEmojis(stateEmoji);
    }
  }, [emojis, editingIndex, multiPost, caretPosition, setCaretPosition, setPostEditorData, setText, setEmojis, handleCursorUpdate]);
  
  useEffect(() => {
    if (shouldChange) {
      setNewTextState(decorateState(EditorDefaultState));
    }
    setShouldChange(false);
  }, [shouldChange]);

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  // const handleTextChange = (e) => {
    //   // console.log('change text', e);
  //   // const text = contentBlock.getText();
  //   setText?.(text);
  //   // adjustHeight(event.target);
  // };

  // const handleContentChange = (e, index) => {
  //   const newMultiPost = multiPost.map((item, i) => {
  //     if (i === index) {
  //       setText(e.target.value)
  //       return { ...item, content: e.target.value };
  //     }
  //     return item;
  //   });
  //   setMultiPost(newMultiPost);
  //   adjustHeight(event.target);
  // };
  // console.log(multiPost,"newTextState.getCurrentContent().getPlainText()")

  const handleContentChange = (e, index) => {
    // Reset isRemoved when content changes
    setIsRemoved(false);
    lastTextareaSelectionRef.current = {
      start: e.target.selectionStart,
      end: e.target.selectionEnd,
    };
    
    const newMultiPost = multiPost.map((item, i) => {
      if (i === index) {
        const nextValue = e.target.value;
        (multiPost?.length >= 1 && mode === 'edit') && setText(nextValue);
        return { ...item, content: nextValue };
      }
      return item;
    });
    setMultiPost(newMultiPost);
    adjustHeight(e.target);
    detectSuggestionsPlain(e.target.value, e.target.selectionStart);

    // Detect and remove mentions that are no longer in the text
    if (mentionedUser && mentionedUser.length > 0) {
      const mentionPattern = /@([^\n@#]+)/g;
      const mentionedNames = [];
      let match;
      while ((match = mentionPattern.exec(e.target.value)) !== null) {
        mentionedNames.push(match[1].trim().toLowerCase());
      }
      
      setMentionedUser((prev) => {
        return prev.filter((user) => {
          const userName = (user.name || '').toLowerCase();
          return mentionedNames.some((name) => userName.includes(name) || name.includes(userName));
        });
      });
    }
  };

  const adjustHeight = (element) => {
    element.style.height = 'auto';
    element.style.height = element.scrollHeight + 'px';
  };

  useEffect(() => {
    if (textareaRef.current) {
      adjustHeight(textareaRef.current);
    }
  }, [text, multiPost]);

  useEffect(() => {
    if (isCharLimitReached) {
      setIsDisable(true);
    } else {
      setIsDisable(false);
    }
  }, [isCharLimitReached, setIsDisable]);

  // const displayText = text.slice(0, 250);
  // const extraText = text.slice(250);

  const contentDisplay = useCallback(
    (index) => {
      return multiPost[index].content?.slice(0, 250);
    },
    [multiPost]
  );

  const extraContentDisplay = useCallback(
    (index) => {
      if (multiPost[index].content?.slice(250)) {
        setIsDisable(true);
      } else {
        setIsDisable(false);
      }
      return multiPost[index].content?.slice(250);
    },
    [multiPost]
  );

  // const handleDeleteLastPost = () => {
  //   setMultiPost((prevPosts) => prevPosts.slice(0, -1));
  // };

  const handleEditingPost = (index) => {
    setIsRemoved(false);
    editingIndexHandler(index);
  };

  // Focus the correct textarea when editingIndex changes (works in both create and edit modes)
  useEffect(() => {
    if (editingIndex !== null && multiPost?.length > 0) {
      setTimeout(() => {
        const textarea = textareaRefs.current[editingIndex];
        if (textarea) {
          textarea.focus();
          // Sync the shared context ref to the newly active textarea
          if (textareaRef) textareaRef.current = textarea;
          handleCursorUpdate(textarea);
        }
      }, 100);
    }
  }, [editingIndex, mode, multiPost?.length]);
  
  // SYNC: multiPost[editingIndex] -> global context state
  // This ensures that when we click a post to edit, the global context (used by pickers)
  // is updated with that post's data.
  useEffect(() => {
    if (mode === 'edit' && editingIndex !== null && multiPost && multiPost[editingIndex]) {
      const post = multiPost[editingIndex];
      
      // Sync Text
      const postText = post.content || post.text || '';
      if (text !== postText) {
        setText(postText);
        const contentState = ContentState.createFromText(postText);
        const newEditorState = decorateState(
          EditorState.createWithContent(contentState, mentionHashtagDecorator)
        );
        setNewTextState(newEditorState);
        setPostEditorData(newEditorState);
      }

      // Sync Gifs
      const postGif = post.gif || (post.gifs && post.gifs.length > 0 ? (post.gifs[0]?.images?.original?.url || post.gifs[0]) : null);
      if (postGif) {
        setGifs([{ images: { original: { url: postGif } } }]);
      } else {
        setGifs([]);
      }
      
      // Sync Images/Videos
      const media = post.media || post.images || post.videos || [];
      const vids = media.filter(m => {
        const file = m?.file || m;
        return typeof file === 'string' && (file.toLowerCase().includes('mp4') || m?.type === 'GIF');
      });
      const imgs = media.filter(m => {
        const file = m?.file || m;
        return !(typeof file === 'string' && (file.toLowerCase().includes('mp4') || m?.type === 'GIF'));
      });
      
      if (vids.length > 0) {
        setVideos(vids.map(v => v?.file || v));
        setImages([]);
      } else if (imgs.length > 0) {
        setImages(imgs.map(i => i?.file || i));
        setVideos([]);
      } else {
        setImages([]);
        setVideos([]);
      }
      
      // Sync other properties
      setFeeling(post.feelings || post.feeling || null);
      setTagged(post.tagged || []);
      setVisibility(post.visibility || 0);
    }
  }, [editingIndex, mode]);

  useEffect(() => {
    // SYNC: global context state -> multiPost[editingIndex]
    // This handles updates from pickers (Giphy, Image upload, etc.)
    if (mode === 'edit' && editingIndex !== null && multiPost?.length > 0) {
      const newMultiPost = multiPost?.map((item, i) => {
        if (i === editingIndex) {
          const newMedia = images?.length ? images : (videos?.length ? videos : []);
          const newGif = gifs?.length ? (gifs[0]?.images?.original?.url || gifs[0]) : null;
          
          // Check if media actually changed to avoid unnecessary updates and correctly set media_updated
          const mediaChanged = 
            item.gif !== newGif ||
            !isSameMediaList(item.media || [], newMedia || []);
          
          return {
            ...item,
            media: newMedia,
            gif: newGif,
            tagged: tagged?.length ? tagged : item.tagged,
            feelings: feeling || item.feelings,
            visibility: visibility !== undefined ? visibility : item.visibility,
            // Only mark this specific post as media_updated if its media changed
            media_updated: item.media_updated || mediaChanged
          };
        }
        return item;
      });
      
      if (JSON.stringify(newMultiPost) !== JSON.stringify(multiPost)) {
        setMultiPost(newMultiPost);
      }
    }
  }, [images, gifs, videos, tagged, feeling, visibility, isSameMediaList]);

const handleRemove=()=>{
  cancelAll?.();
  // Remove the currently active post and load the previous one
  if (mode === 'create') {
    // In create mode, when removing active post, load the last saved post from queue
    if (multiPost.length > 0) {
      const lastSavedPost = multiPost[multiPost.length - 1];
      
      // Load the last saved post data into the editor
      setText(lastSavedPost.text || '');
      setImages(lastSavedPost.images || []);
      setGifs(lastSavedPost.gifs || []);
      setVideos(lastSavedPost.videos || []);
      setTagged(lastSavedPost.tagged || []);
      setVisibility(lastSavedPost.visibility || 0);
      setFeeling(lastSavedPost.feeling || null);
      
      const contentState = ContentState.createFromText(lastSavedPost.text || '');
      const newEditorState = decorateState(
        EditorState.createWithContent(contentState, mentionHashtagDecorator)
      );
      setNewTextState(newEditorState);
      setPostEditorData(newEditorState);
      
      // Remove the last saved post from the queue (it's now in the editor)
      setMultiPost((prevPosts) => prevPosts.slice(0, -1));
    } else {
      // No posts in queue, just clear the editor
      setText('');
      setImages([]);
      setGifs([]);
      setVideos([]);
      setTagged([]);
      setVisibility(0);
      setFeeling(null);
      const cleared = decorateState(EditorDefaultState);
      setNewTextState(cleared);
      setPostEditorData(cleared);
    }
  } else if (mode === 'edit') {
    // In edit mode
    setMultiPost((prevPosts) => {
      if (prevPosts.length > 0) {
        const lastPost = prevPosts[prevPosts.length - 1];
        setIsRemoved(true);
        
        // Ensure that media are properly extracted in edit mode
        const mediaFiles = Array.isArray(lastPost?.media)
          ? lastPost.media.map((mediaItem) => mediaItem.file).filter(Boolean)
          : lastPost.media?.file
          ? [lastPost.media.file]
          : [];

        // Update state with the last post's details in edit mode
        setText(lastPost.content || text);
        setImages(mediaFiles.length > 0 ? mediaFiles : images);
        setGifs(
          lastPost.gif
            ? [
                {
                  images: {
                    original: { url: lastPost.gif },
                  },
                },
              ]
            : gifs
        );
        setVideos(mediaFiles.length > 0 ? mediaFiles : videos);
        setTagged(lastPost.tagged || tagged);
        setVisibility(lastPost.visibility || visibility);
        setFeeling(lastPost.feeling || feeling);
        
        // Remove only the last post in edit mode
        return prevPosts.slice(0, -1);
      }
      return prevPosts;
    });
  }

  const payload = {
    id: deletedChildId,
  };

  // deletedChildId&&dispatch(postDelete(payload))
  deletedChildId&&deletePost(payload);
  setdeletedChildId(null)
  handleCloseRemoveChildPost()
}

  const handleDeleteLastPost = (post) => {
    if(post?.id){
      setIsRemoveChildModalOpen(true)
      setdeletedChildId(post?.id)
    }else{

      !post?.id&&handleRemove()
    }
  };
  const handleCloseRemoveChildPost=()=>{
    setIsRemoveChildModalOpen(false)
  }
  
  // const updateEditorState =(newState) => {
    //   // const updatedEditors = [...postEditorData];
  //   // updatedEditors[index] = { id: index, editorState: newState };
  //   // setPostEditorData(updatedEditors);
  //   setPostEditorData(newState);
  // };

  useEffect(() => {
    if (companyDetails?.id) {
      dispatch(currentProfile(companyDetails));
      setIsCompany(true);
    } else {
      dispatch(currentProfile(null));
      setIsCompany(false);
    }
  }, [companyDetails]);

  return (
    <Box className="postChildCreateContainer">
       {!!isRemoveChildModalOpen &&(
        <DeleteChildPost handleRemove={handleRemove} onClose={handleCloseRemoveChildPost} />
      )}
      {multiPost &&
        multiPost.length > 0 &&
        multiPost.map((field, index) => {
          return mode === 'create' ? (
            // CREATE MODE – each queued post is now fully editable; clicking it sets it as the active post
            <Box
              key={field.id}
              pb="30px"
              className="postHasChildCreate"
              opacity={editingIndex === index ? '100%' : '60%'}
            >
              <HStack alignItems="flex-start">
                <PostAvatar
                  companyDetails={selectedPostingProfile}
                  multiPost={index ? multiPost : null}
                />
                <Stack
                  w="100%"
                  spacing={2}
                  justifyContent="flex-start"
                  overflow="hidden"
                >
                  <Box position="relative" w="100%">
                    {/* Highlight layer – mirrors text for mention/hashtag coloring */}
                    <Box
                      position="absolute"
                      top={0}
                      left={0}
                      right={0}
                      pt={'15px'}
                      pl="8px"
                      pr="8px"
                      pb={0}
                      fontSize="16px"
                      whiteSpace="pre-wrap"
                      wordBreak="break-word"
                      pointerEvents="none"
                      color="#1D1D1F"
                      minH="40px"
                      overflowY="auto"
                      borderRadius="xl"
                      border={!setOpenPostModal ? 'none' : '1px solid #EFEFEF'}
                      fontFamily="Inter"
                      lineHeight="19.2px"
                      letterSpacing="normal"
                      boxSizing="border-box"
                      margin={0}
                      fontWeight="normal"
                      dangerouslySetInnerHTML={{
                        __html: highlightMentionsHashtags(
                          multiPost[index].content
                            ? multiPost[index].content.charAt(0).toUpperCase() + multiPost[index].content.slice(1)
                            : ''
                        ),
                      }}
                    />
                    {/* Editable textarea – transparent text so highlight layer shows through */}
                    <Textarea
                      ref={(el) => {
                        textareaRefs.current[index] = el;
                        // Also keep the shared context ref in sync for the active post
                        if (editingIndex === index && textareaRef) {
                          textareaRef.current = el;
                        }
                      }}
                      outline="none"
                      _focusVisible={{ outline: 'none' }}
                      minH="40px"
                      bg="transparent"
                      autoFocus={editingIndex === index}
                      resize="none"
                      onMouseDown={(e) => {
                        e.stopPropagation();
                        // Switch active post before the focus event fires
                        if (editingIndex !== index) {
                          editingIndexHandler(index);
                          if (textareaRef) textareaRef.current = textareaRefs.current[index];
                        }
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleTextClick(e);
                        if (editingIndex !== index) {
                          editingIndexHandler(index);
                          if (textareaRef) textareaRef.current = textareaRefs.current[index];
                        }
                        const target = e.target;
                        if (target?.tagName === 'TEXTAREA') {
                          setTimeout(() => {
                            target.focus();
                            handleCursorUpdate(target);
                          }, 0);
                        }
                      }}
                      onFocus={(e) => {
                        e.stopPropagation();
                        if (editingIndex !== index) {
                          editingIndexHandler(index);
                          if (textareaRef) textareaRef.current = textareaRefs.current[index];
                        }
                        handleCursorUpdate(e.target);
                      }}
                      onKeyUp={(e) => handleCursorUpdate(e.target)}
                      onSelect={(e) => handleCursorUpdate(e.target)}
                      onChange={(e) => {
                        handleContentChange(e, index);
                        handleCursorUpdate(e.target);
                      }}
                      value={
                        multiPost[index].content
                          ? multiPost[index].content.charAt(0).toUpperCase() + multiPost[index].content.slice(1)
                          : ''
                      }
                      borderRadius="xl"
                      overflowY="auto"
                      fontSize="16px"
                      pt={'15px'}
                      pl="8px"
                      pr="8px"
                      border={!setOpenPostModal ? 'none' : '1px solid #EFEFEF'}
                      placeholder={`${t('postEditor.whatsOnYourMind') || "What's on your mind"} ${
                        selectedPostingProfile
                          ? selectedPostingProfile?.name
                          : userProfileInfo?.first_name
                      }?`}
                      style={{
                        width: '100%',
                        zIndex: 1,
                        background: 'transparent',
                        color: 'transparent',
                        caretColor: '#1D1D1F',
                        fontFamily: 'Inter',
                        lineHeight: '19.2px',
                        letterSpacing: 'normal',
                        boxSizing: 'border-box',
                        margin: 0,
                        paddingBottom: 0,
                        fontWeight: 'normal',
                      }}
                    />
                    {/* Mention/hashtag suggestion list for create-mode queued posts */}
                    {showSuggestionList && activeTrigger && editingIndex === index && (
                      <Box
                        mt={2}
                        border="1px solid #EFEFEF"
                        borderRadius="12px"
                        bg="white"
                        maxH="220px"
                        overflowY="auto"
                        boxShadow="md"
                      >
                        {(filteredSuggestions ?? []).length ? (
                          filteredSuggestions.map((item, idx) => (
                            <HStack
                              key={`${activeTrigger}-suggestion-${idx}-${getSuggestionLabel(item, activeTrigger)}`}
                              p={3}
                              spacing={3}
                              cursor="pointer"
                              _hover={{ backgroundColor: '#F8F8F8' }}
                              onMouseDown={(e) => {
                                e.preventDefault();
                                handleSuggestionSelect(item, activeTrigger);
                              }}
                            >
                              {activeTrigger === 'mention' ? (
                                <Avatar
                                  size="sm"
                                  name={getSuggestionLabel(item, activeTrigger)}
                                  src={getSuggestionAvatar(item)}
                                />
                              ) : null}
                              <Stack spacing={0}>
                                <Box fontWeight="600" color="#1D1D1F">
                                  {getSuggestionLabel(item, activeTrigger)}
                                </Box>
                                {activeTrigger === 'mention' && item?.position ? (
                                  <Box fontSize="12px" color="#5B5B5B">
                                    {item.position}{item?.company ? ` | ${item.company}` : (item?.company_name && ` | ${item.company_name}`)}
                                  </Box>
                                ) : activeTrigger === 'hashtag' && item?.count ? (
                                  <Box fontSize="12px" color="#5B5B5B">
                                    {item.count} {item.count === 1 ? 'post' : 'posts'}
                                  </Box>
                                ) : null}
                              </Stack>
                            </HStack>
                          ))
                        ) : (apiMentionUsersFetching || apiHashtagsFetching) ? (
                          <HStack p={3} justifyContent="center"><Spinner /></HStack>
                        ) : (
                          <Box p={3} color="#5B5B5B">
                            {activeTrigger === 'mention'
                              ? t('scheduling.noUserFound') || 'No users found!'
                              : t('postEditor.noHashtagsFound') || 'No hashtags found!'}
                          </Box>
                        )}
                      </Box>
                    )}
                    {!fromQuote && (
                      <Stack overflowX="hidden" flex={1}>
                        <AvailableMediaContainer
                          images={field?.images?.length ? field?.images : field?.media}
                          videos={field?.videos?.length ? field?.videos : field?.media}
                          gifs={field?.gifs?.length ? field?.gifs : [field?.gif]}
                        />
                      </Stack>
                    )}
                  </Box>
                </Stack>
              </HStack>
            </Box>
          ) : field.mode === 'edit' && multiPost?.length >= 1 ? (
            <HStack
              alignItems="flex-start"
              opacity={editingIndex === index ? '100%' : '40%'}
              onClick={() => handleEditingPost(index)}
            >
              <Box
                as="div"
                display="flex"
                flexDirection="column"
                alignItems="flex-center"
                justifyContent="flex-center"
              >
                <PostAvatar
                  companyDetails={selectedPostingProfile}
                  multiPost={index === 0 ? null : multiPost}
                />
                {index!==0 ? (
                  <IconButton
                    style={{ backgroundColor: 'transparent' }}
                    onClick={()=>handleDeleteLastPost(multiPost[index])}
                  >
                    <DeleteIcon width={14} height={16} color="#5B5B5B" />
                  </IconButton>
                ) : (
                  <></>
                )}
              </Box>
              <Stack
                w="100%"
                spacing={2}
                justifyContent="flex-start"
                overflow="hidden"
              >
                <Box position="relative" w="100%">
                <Box
                  position="absolute"
                  top={0}
                  left={0}
                  right={0}
                  pt={'15px'}
                  pl="8px"
                  pr="8px"
                  pb={0}
                  fontSize="16px"
                  whiteSpace="pre-wrap"
                  wordBreak="break-word"
                  pointerEvents="none"
                  color="#1D1D1F"
                  minH="40px"
                  overflowY="auto"
                  borderRadius="xl"
                  border={!setOpenPostModal ? 'none' : '1px solid #EFEFEF'}
                  fontFamily="Inter"
                  lineHeight="19.2px"
                  letterSpacing="normal"
                  boxSizing="border-box"
                  margin={0}
                  fontWeight="normal"
                  dangerouslySetInnerHTML={{
                    __html: highlightMentionsHashtags(
                      multiPost[index].content ? multiPost[index].content.charAt(0).toUpperCase() + multiPost[index].content.slice(1) : ''
                    ),
                  }}
                />
                  <Textarea
                    ref={textareaRef} // Add ref here
                    outline="none"
                    _focusVisible={{ outline: 'none' }}
                    minH="40px"
                    bg="transparent"
                    autoFocus={editingIndex === index}
                    resize="none"
                    contenteditable
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent parent onClick from interfering
                      handleTextClick(e);
                      // Set editing index first to ensure this post is active
                      if (editingIndex !== index) {
                        editingIndexHandler(index);
                      }
                      // Focus the textarea
                      const target = e.target;
                      if (target && target.tagName === 'TEXTAREA') {
                        // Ensure focus
                        setTimeout(() => {
                          target.focus();
                          // Update cursor position
                          handleCursorUpdate(target);
                        }, 0);
                      }
                    }}
                    onFocus={(e) => {
                      // Update cursor when textarea gets focus
                      e.stopPropagation();
                      // Ensure editingIndex is set when this textarea gets focus
                      if (editingIndex !== index) {
                        editingIndexHandler(index);
                      }
                      // Update cursor position
                      handleCursorUpdate(e.target);
                    }}
                    onMouseDown={(e) => {
                      // Set editing index on mouse down to ensure correct post is active
                      if (editingIndex !== index) {
                        editingIndexHandler(index);
                      }
                      e.stopPropagation();
                    }}
                    onKeyUp={(e) => handleCursorUpdate(e.target)}
                    onSelect={(e) => handleCursorUpdate(e.target)}
                    onChange={(e) => {
                      handleContentChange(e, index);
                      handleCursorUpdate(e.target);
                    }}
                    value={multiPost[index].content ? multiPost[index].content.charAt(0).toUpperCase() + multiPost[index].content.slice(1) : ''}
                    borderRadius="xl"
                    overflowY="auto"
                    fontSize="16px"
                    pt={'15px'}
                    pl="8px"
                    pr="8px"
                    border={!setOpenPostModal ? 'none' : '1px solid #EFEFEF'}
                    placeholder={`${t('postEditor.whatsOnYourMind') || "What's on your mind"}  ${selectedPostingProfile
                      ? selectedPostingProfile?.name
                      : userProfileInfo?.first_name
                      }?`}
                    style={{
                    width: '100%',
                    zIndex: 1,
                    background: 'transparent',
                    color: 'transparent',
                    caretColor: '#1D1D1F',
                    fontFamily: 'Inter',
                    lineHeight: '19.2px',
                    letterSpacing: 'normal',
                    boxSizing: 'border-box',
                    margin: 0,
                    paddingBottom: 0,
                    fontWeight: 'normal',
                  }}
                  />
                {showSuggestionList && activeTrigger && editingIndex === index && (
                  <Box
                    mt={2}
                    border="1px solid #EFEFEF"
                    borderRadius="12px"
                    bg="white"
                    maxH="220px"
                    overflowY="auto"
                    boxShadow="md"
                  >
                    {(filteredSuggestions ?? []).length ? (
                      filteredSuggestions.map((item, idx) => (
                        <HStack
                          key={`${activeTrigger}-suggestion-${idx}-${getSuggestionLabel(
                            item,
                            activeTrigger
                          )}`}
                          p={3}
                          spacing={3}
                          cursor="pointer"
                          _hover={{ backgroundColor: '#F8F8F8' }}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            handleSuggestionSelect(item, activeTrigger);
                          }}
                        >
                          {activeTrigger === 'mention' ? (
                            <Avatar
                              size="sm"
                              name={getSuggestionLabel(item, activeTrigger)}
                              src={getSuggestionAvatar(item)}
                            />
                          ) : null}
                          <Stack spacing={0}>
                            <Box fontWeight="600" color="#1D1D1F">
                              {getSuggestionLabel(item, activeTrigger)}
                            </Box>
                            {activeTrigger === 'mention' && (item?.position) ? (
                                <Box fontSize="12px" color="#5B5B5B">
                                  {item.position}{item?.company ? ` | ${item?.company}` : (item?.company_name && ` | ${item?.company_name}`)}
                                </Box>
                            ) : activeTrigger === 'hashtag' && item?.count ? (
                              <Box fontSize="12px" color="#5B5B5B">
                                {item.count} {item.count === 1 ? 'post' : 'posts'}
                              </Box>
                            ) : null}
                          </Stack>
                        </HStack>
                      ))
                    ) : (apiMentionUsersFetching || apiHashtagsFetching) ? (
                      <HStack p={3} justifyContent="center">
                        <Spinner/>
                      </HStack>
                    ) : (
                      <Box p={3} color="#5B5B5B">
                        {activeTrigger === 'mention'
                          ? t('scheduling.noUserFound') ||
                            'No users found!'
                          : t('postEditor.noHashtagsFound') ||
                            'No hashtags found!'}
                      </Box>
                    )}
                  </Box>
                )}
                  {!fromQuote && (
                    <Stack overflowX="hidden" flex={1} zIndex={99}>
                      <AvailableEditableMediaContainer
                        itemIndex={index}
                        images={field?.media}
                        videos={field?.media}
                        gifs={[field?.gif]}
                      />
                    </Stack>
                  )}
                </Box>
                
                {/* Quoted post preview – only for the first post in the thread so it stays anchored to post[0] */}
                {index === 0 && repost && repostBoxContext ? (
                  <PostBoxContext.Provider value={repostBoxContext}>
                    <Stack
                      spacing={0}
                      border="1px solid"
                      borderColor="gray.200"
                      borderRadius={5}
                      bg="#EFEFEF"
                      pb={2}
                      mt={2}
                    >
                      <PostBoxHeaderDisplay actionMenuEnabled={false} fromQuote={true} />
                      <PostBoxBody isQuoted={true} />
                    </Stack>
                  </PostBoxContext.Provider>
                ) : null}
              </Stack>
              
            </HStack>
          ) : null;
        })}
      {mode === 'create' || (mode === 'edit' && !multiPost) ? (
        // Dim the main editor when a queued post is active (editingIndex < multiPost.length)
        <HStack
          display="flex"
          alignItems="flex-start"
          opacity={multiPost?.length && editingIndex !== multiPost.length ? '60%' : '100%'}
        >
          <Box
            as="div"
            display="flex"
            flexDirection="column"
            alignItems="flex-center"
            justifyContent="flex-center"
          >
            {!fromProfile&&(<PostAvatar
              companyDetails={selectedPostingProfile}
              multiPost={multiPost?.length === 0 ? null : multiPost}
            />)}
            {multiPost?.length ? (
              <IconButton
                style={{ backgroundColor: 'transparent' }}
                onClick={()=>handleDeleteLastPost()}
              >
                <DeleteIcon width={14} height={16} color="#5B5B5B" />
              </IconButton>
            ) : (
              <></>
            )}
          </Box>
          <Stack
            w="100%"
            spacing={2}
            justifyContent="flex-start"
            overflow="hidden"
          >
            <Box position="relative" w="100%">


          {fromProfile&&(  <div  onClick={handleTextClick}  style={{ display: 'flex', alignItems: 'center' }} >
                <PlusIcon style={{ height: '18px', width: '18px' }} />
                <span  style={{fontWeight:"600", marginLeft: '8px', color: ' #3D5A80', cursor: "pointer" }}>{t('createPost.createPost') || "Create Post"}</span>
              </div>)}
             {!fromProfile&&( <Box
                as="div"
                whiteSpace="pre-wrap"
                marginTop={"5px"}
                wordBreak="break-word"
                minH="50px"
                fontSize="16px"
                // pt={placeholderText ? '0px' : '10px'}
                // pl="8px"
                // pr="8px"
                bg="transparent"
                borderRadius={pagePost ? '40px' : 'xl'}
                // maxH="65px"
                overflowY="hidden"
                border={!setOpenPostModal ? 'none' : '1px solid #EFEFEF'}
                onClick={()=>{
                  editingIndexHandler(multiPost?.length || 0)
                  handleTextClick()
                }}
                className="postEditorContainer"
              // style={{ background: "red" }}
              >
                <Box
                  sx={{
                    '.public-DraftEditor-content[contenteditable="true"]': {
                      WebkitUserModify: 'read-write-plaintext-only',
                      height: 'auto',
                    }
                  }}
                >
                  <Editor
                    editorState={newTextState}
                    onChange={handleEditorChange}
                    placeholder={
                      multiPost?.length
                        ? t('postEditor.addAnotherPost') || 'Add another post'
                        : `${t('postEditor.whatsOnYourMind') || "What's on your mind"} ${
                            selectedPostingProfile
                              ? selectedPostingProfile?.name
                              : userProfileInfo?.first_name
                          }?`
                    }
                  />
                  {showSuggestionList && activeTrigger && (
                    <Box
                      mt={2}
                      border="1px solid #EFEFEF"
                      borderRadius="12px"
                      bg="white"
                      maxH="220px"
                      overflowY="auto"
                      boxShadow="md"
                    >
                      {(filteredSuggestions ?? []).length ? (
                        filteredSuggestions.map((item, idx) => (
                          <HStack
                            key={`${activeTrigger}-suggestion-${idx}-${getSuggestionLabel(
                              item,
                              activeTrigger
                            )}`}
                            p={3}
                            spacing={3}
                            cursor="pointer"
                            _hover={{ backgroundColor: '#F8F8F8' }}
                            onMouseDown={(e) => {
                              // Prevent editor blur so selection stays intact
                              e.preventDefault();
                              handleSuggestionSelect(item, activeTrigger);
                            }}
                          >
                            {activeTrigger === 'mention' ? (
                              <Avatar
                                size="sm"
                                name={getSuggestionLabel(item, activeTrigger)}
                                src={getSuggestionAvatar(item)}
                              />
                            ) : null}
                            <Stack spacing={0}>
                              <Box fontWeight="600" color="#1D1D1F">
                                {getSuggestionLabel(item, activeTrigger)}
                              </Box>
                              {activeTrigger === 'mention' && (item?.position) ? (
                                <Box fontSize="12px" color="#5B5B5B">
                                  {item.position}{item?.company ? ` | ${item?.company}` : (item?.company_name && ` | ${item?.company_name}`)}
                                </Box>
                              ) : activeTrigger === 'hashtag' && item?.count ? (
                                <Box fontSize="12px" color="#5B5B5B">
                                  {item.count} {item.count === 1 ? 'post' : 'posts'}
                                </Box>
                              ) : null}
                            </Stack>
                          </HStack>
                        ))
                      ) : (apiMentionUsersFetching || apiHashtagsFetching) ? (
                        <HStack p={3} justifyContent="center">
                          <Spinner/>
                        </HStack>
                      ) : (
                        <Box p={3} color="#5B5B5B">
                          {activeTrigger === 'mention'
                            ? t('scheduling.noUserFound') ||
                              'No users found!'
                            : t('postEditor.noHashtagsFound') ||
                              'No hashtags found!'}
                        </Box>
                      )}
                    </Box>
                  )}
                </Box>

                {isCharLimitReached && (
                  <div style={{ color: 'red' }}>
                    {t('postEditor.characterLimit') || 'You have reached the character limit of'} {formatNumber(charLimit)}!
                  </div>
                )}
                
                {!fromQuote && (isPostModalOpen || expanded || images?.length || videos?.length || gifs?.length) && (
                  <Stack overflowX="hidden" flex={1} mt={4}>
                    <AttachedMediaContainer />
                  </Stack>
                )}
              </Box>)}
            </Box>
            <Stack mt={1} display={expanded ? '' : 'none'}>
              <Box flexWrap="wrap">
                {/* <PostFeelingAndTagsText tagged={tagged} feeling={feeling} /> */}
              </Box>
              <HStack mt={2}>{/* <PostVisibilityMenu /> */}</HStack>
            </Stack>
          </Stack>
          {pagePost && (
            <Box mt={3}>
              <FrameIcon color="#868585" />
            </Box>
          )}
        </HStack>
      ) : (
        <></>
      )}
     
    </Box>
  );
};
